let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lgm1i")).then(() => parcelRequire('04Nru'));